"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.translationsNamespace = exports.defaultTranslations = void 0;
/* istanbul ignore file @preserve */

/**
 * DO NOT EDIT!
 * This file was autogenerated by npm script `localizations-codegen`.
 * Changes may cause incorrect behavior and will be lost when the file is regenerated.
 *
 * Run `npx localizations-codegen` to regenerate.
 */

const defaultTranslations = exports.defaultTranslations = {
  addAddressFeedback: 'Added!',
  cancel: 'Cancel',
  cannotUpdate: 'Cannot update item',
  confirmEmailDelete: 'Do you really want to delete this email?',
  currentEmail: 'Current e-mail',
  currentEmailTitle: 'Current e-mail',
  delete: 'Delete',
  deleteEmail: 'Delete e-mail',
  deletedFeedback: 'Deleted',
  disabledVerificationEmail: 'Confirmation email sent. Resent email in 1 minute.',
  edit: 'Edit',
  editAddressFeedback: 'Success!',
  emailAnnotation: 'Some text about email',
  emailConfirmationNeeded: "Please check your inbox and confirm your new e-mail. Didn't get it? {link}",
  emailPlaceholder: '@',
  emailTitle: 'E-mail',
  emailToConfirm: 'A confirmation will be sent to your e-mail.',
  enterEmailTitle: 'Enter your email address',
  errorOccured: 'An error occurred',
  infoConfirmDialog: 'Now all you need to do is confirm your e-mail address. Please check your inbox and confirm.',
  newEmail: 'New e-mail',
  orderInformation: 'We will use this information for order confirmation and delivery notification',
  pendingEmail: 'New e-mail pending',
  pendingEmailTitle: 'Below is your current e-mail. You can change it by editing the field below.',
  save: 'Save',
  sendAgain: 'Resend confirmation',
  validationEmailTerminatedCustomer: 'Cannot change email for terminated customer',
  validationLength: 'Invalid property length',
  validationRegex: 'This field value does not match requested conditions',
  validationRegexEmail: 'Please enter a valid email in the format my@mail.com',
  validationRequired: 'This field is required',
  validationUniqueEmail: 'Email is already used',
  verifiedFeedback: 'Verified',
  waitingConfirmationEmail: 'Check inbox and confirm this e-mail. {link}'
};
const translationsNamespace = exports.translationsNamespace = 'email-manager';
